import { RECEIVE_ENABLED_FEATURES, RECEIVE_FEATURE_FLAG } from '../actions/optimizely';

const initialState = {};

export default function optimizelyData(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_ENABLED_FEATURES:
      return action.data.reduce((agg, key) => ({ ...agg, [key]: true }), {});
    case RECEIVE_FEATURE_FLAG:
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
}
